import { Action, createReducer, on } from '@ngrx/store'

import * as QUARTERLY_DASHBOARD_ACTIONS from './quarterly-dashboard.actions'
import { createQuarterlyDashboardInitState, IQuarterlyDashboardState } from './quarterly-dashboard.state'

export const quarterlyDashboardState = createReducer(
  createQuarterlyDashboardInitState(),

  // quarter
  on(QUARTERLY_DASHBOARD_ACTIONS.getQuarterlyDashboardQuarterData, state => ({
    ...state,
    quarter: {
      ...state.quarter,
      inRequest: true,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardQuarterSuccess, (state, { data, effective }) => ({
    ...state,
    quarter: {
      ...state.quarter,
      initialized: true,
      inRequest: false,
      error: undefined,
      data,
      effective,
    },
  })),
  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardQuarterError, (state, { error }) => ({
    ...state,
    quarter: {
      ...state.quarter,
      initialized: true,
      inRequest: false,
      error,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardQuarterSelected, (state, { selected }) => ({
    ...state,
    quarter: {
      ...state.quarter,
      selected,
    },
  })),

  // market cap
  on(QUARTERLY_DASHBOARD_ACTIONS.getQuarterlyDashboardMktCapData, state => ({
    ...state,
    mktCap: {
      ...state.mktCap,
      inRequest: true,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardMktCapSuccess, (state, { data, quarter }) => ({
    ...state,
    mktCap: {
      ...state.mktCap,
      initialized: true,
      inRequest: false,
      error: undefined,
      data,
      quarter,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardMktCapError, (state, { error }) => ({
    ...state,
    mktCap: {
      ...state.mktCap,
      initialized: true,
      inRequest: false,
      error,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardMktCapSort, (state, { sortBy, order }) => ({
    ...state,
    mktCap: {
      ...state.mktCap,
      initialized: false,
      sortBy,
      order,
    },
  })),

  // sector
  on(QUARTERLY_DASHBOARD_ACTIONS.getQuarterlyDashboardSectorData, state => ({
    ...state,
    sector: {
      ...state.sector,
      inRequest: true,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardSectorSuccess, (state, { data, quarter }) => ({
    ...state,
    sector: {
      ...state.sector,
      initialized: true,
      inRequest: false,
      error: undefined,
      data,
      quarter,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardSectorError, (state, { error }) => ({
    ...state,
    sector: {
      ...state.sector,
      initialized: true,
      inRequest: false,
      error,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardSectorSort, (state, { sortBy, order }) => ({
    ...state,
    sector: {
      ...state.sector,
      initialized: false,
      sortBy,
      order,
    },
  })),

  // sector top 500
  on(QUARTERLY_DASHBOARD_ACTIONS.getQuarterlyDashboardSectorTop500Data, state => ({
    ...state,
    sectorTop500: {
      ...state.sectorTop500,
      inRequest: true,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardSectorTop500Success, (state, { data, quarter }) => ({
    ...state,
    sectorTop500: {
      ...state.sectorTop500,
      initialized: true,
      inRequest: false,
      error: undefined,
      data,
      quarter,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardSectorTop500Error, (state, { error }) => ({
    ...state,
    sectorTop500: {
      ...state.sectorTop500,
      initialized: true,
      inRequest: false,
      error,
    },
  })),

  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardSectorTop500Sort, (state, { sortBy, order }) => ({
    ...state,
    sectorTop500: {
      ...state.sectorTop500,
      initialized: false,
      sortBy,
      order,
    },
  })),

  // view mode
  on(QUARTERLY_DASHBOARD_ACTIONS.setQuarterlyDashboardViewMode, (state, { viewMode }) => ({
    ...state,
    viewMode,
  }))
)

export const quarterlyDashboardReducer = (state: IQuarterlyDashboardState, action: Action): IQuarterlyDashboardState =>
  quarterlyDashboardState(state, action)
